import { render } from "./NpcReclaimModal.vue?vue&type=template&id=582fcd5c&scoped=true"
import script from "./NpcReclaimModal.vue?vue&type=script&lang=js"
export * from "./NpcReclaimModal.vue?vue&type=script&lang=js"

import "./NpcReclaimModal.vue?vue&type=style&index=0&id=582fcd5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582fcd5c"]])

export default __exports__